import apiClient from "../../axios/apiClient";

export const getUsertypeList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERTYPELIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Usertype`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_USERTYPELIST_FULFILLED",
        payload: response.data?.data,
        usertypeCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_USERTYPELIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveUsertypeData = (token, data) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_USERTYPE_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Usertype`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_USERTYPE_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "ADD_USERTYPE_REJECTED", payload: error.response });
    }
  };
  

  export const getUsertypeListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERTYPELISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Usertype/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_USERTYPELISTBYID_FULFILLED",
        payload: response.data?.data,
        usertypeCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_USERTYPELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateUsertypeData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_USERTYPE_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Usertype/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USERTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_USERTYPE_REJECTED", payload: error.response });
  }
};


export const deleteUsertypeData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_USERTYPE_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Usertype/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_USERTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_USERTYPE_REJECTED", payload: error.response });
  }
};
